import React, { useState } from 'react';
import {
  MdOutlineExitToApp,
  MdOutlineKeyboardArrowDown,
  MdOutlineKeyboardArrowUp,
} from 'react-icons/md';
import { BiUser } from 'react-icons/bi';

import Avatar from 'components/Granel/Avatar';
import DropdownWrapper from 'components/layout/DropdownWrapper';
import { signOut } from 'utils/functions';

import {
  AccountContainer,
  AvatarContainer,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownText,
  IconContainer,
} from './styles';

const UserMenuIcon = (): JSX.Element => {
  const [show, setShow] = useState(false);

  const toggleShow = (): void => {
    setShow((prevState) => !prevState);
  };

  const routePerfil = (): void => {
    window.location.href = '/perfil';
  };

  return (
    <Container>
      <AccountContainer onClick={toggleShow}>
        <AvatarContainer>
          <Avatar />
        </AvatarContainer>
        <IconContainer>
          {show ? <MdOutlineKeyboardArrowUp /> : <MdOutlineKeyboardArrowDown />}
        </IconContainer>
      </AccountContainer>
      {show && (
        <DropdownWrapper hideDropdown={toggleShow}>
          <DropdownMenu>
            <DropdownItem onClick={routePerfil}>
              <BiUser />
              <DropdownText>Perfil</DropdownText>
            </DropdownItem>
            <DropdownItem onClick={signOut}>
              <MdOutlineExitToApp />
              <DropdownText>Sair</DropdownText>
            </DropdownItem>
          </DropdownMenu>
        </DropdownWrapper>
      )}
    </Container>
  );
};

export default UserMenuIcon;
